import { useEffect, useState } from 'react';
import { apiCall } from '../../utils/fetchAPI';
import { useCityInView } from './useHubCity';

/**
 * The city in view, and its neighborhoods.
 *
 * Every neighbourhood-scoped screen needs the same two lists. Which city it is
 * is not this hook's decision — a resident's own, a visitor's choice — so it
 * asks {@see useCityInView} and fetches the neighbourhoods of whatever comes
 * back.
 */
export function useCityReference() {
  const { city, cityParam } = useCityInView();
  const [neighborhoods, setNeighborhoods] = useState([]);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        if (!city) {
          setNeighborhoods([]);
          return;
        }

        const neighborhoodsResponse = await apiCall(
          `/cities/${city.slug}/neighborhoods`,
          { method: 'GET' }
        );

        if (!neighborhoodsResponse.ok) return;

        const neighborhoodsData = await neighborhoodsResponse.json();

        if (!cancelled) {
          setNeighborhoods(neighborhoodsData.data || []);
        }
      } catch {
        // The screens using this degrade to "no neighborhood filter" rather
        // than showing an error for something secondary.
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, [city]);

  return { city, neighborhoods, cityParam };
}
